import type { IUserSubscriptions } from "~common/types/user";
import { ILocation as ILocationConfig } from "~/interfaces";

export enum ELoginState {
	Green = "green",
	Orange = "orange",
	Red = "red",
}

export enum ESETTINGS_KEYS {
	REVIEW_NOTIFICATIONS_ENABLED = "review_notifications_enabled",
	REVIEW_NOTIFICATIONS_FROM = "review_notifications_from",
	MAPSET_WEB_DEFAULT_ID = "mapset_web_default_id",
	MAPSET_WEB_LAST_ID = "mapset_web_last_id",
	SEARCH_MAP_SUPPRESSION = "search_map_suppression_enabled",
	MAP_POSITION_WEB_DEFAULT = "map_position_web_default",
	ROUTING_WEB_DEFAULT_CRITERION = "routing_web_default_criterion",
	MAPSET_WEB_OVERLAYS = "mapset_web_overlays",
	RIBBON_ENABLED = "ribbon_enabled",
	ROUTING_CRITERION_SPEED = "routing_criterion_speed",
}

export interface IUserInitialPosition {
	title: string;
	mark: {
		lat: number;
		lon: number;
	},
	source: string;
	source_id: string | number;
	zoom: number;
}

export interface IUserSpeedData {
	[key: string]: {
		value: number;
	};
}

export interface IUserSetting {
	id: string;
	title: ESETTINGS_KEYS,
	public: boolean;
	create_time: number;
	update_time: number;
	deleted: boolean;
	type: "settings",
	data: {
		value: boolean;
		type: "boolean";
	} | {
		value: number;
		type: "number";
	} | {
		value: string;
		type: "string";
	} | {
		value: IUserInitialPosition | Record<string, never> | IUserSpeedData;
		type: "object";
	} | {
		value: Array<any>;
		type: "list";
	}
}

export interface IUserInfo {
	accountDisplayName?: string;
	name: string;
	username: string;
	rusId: number;
	state: ELoginState;
	avatar: string;
	userPublicId: string;
	bankId: boolean;
	phoneOnly: boolean;
	sbr: boolean;
	premium: boolean;
	premiumData: IUserSubscriptions;
}

export interface IUserAccount {
	accountDisplayName: string;
	avatar_url: string;
	color: string;
	flags: {
		bankid: boolean;
		contact: boolean;
		email: boolean;
		phone: boolean;
		phoneOnly: boolean;
		premium: boolean;
		profi: boolean;
		sbr: boolean;
		sznEmployee: boolean;
		verified: boolean;
	};
	isActive: boolean;
	lastActivity: number;
	name: string;
	state: ELoginState;
	userId: number;
}

export interface INotifications {
	total: number;
	totalNew: number;
}

export interface ILocation {
	source: ILocationConfig["source"];
	longitude: number;
	latitude: number;
	accuracy: number;
	timestamp: number;
}

export interface IUserState {
	user: IUserInfo;
	accounts: Array<IUserAccount>;
	settings: Array<IUserSetting>;
	notifications: INotifications;
	location: ILocation;
}

export interface IAuthData {
	status: number;
	data: {
		userName: string;
		userId: number;
		state: string;
		name: string;
		avatarUrl: string;
		bankId: boolean;
		userPublicId: string;
		accountDisplayName: string;
		phoneOnly: boolean;
		premium: boolean,
		premiumData: IUserSubscriptions;
		sznEmployee: boolean;
		sbr: boolean;
	};
}

export interface IUserBadgeItem {
	accountDisplayName: string;
	advertPublicRusId: string;
	avatar_url: string;
	color: ELoginState;
	euconsent: string;
	flags: {
		bankid: boolean;
		contact: boolean;
		email: boolean;
		phone: boolean;
		phoneOnly: boolean;
		premium: boolean;
		sznEmployee: boolean;
		verified: boolean;
		sbr: boolean;
	};
	hasPassword: boolean;
	isActive: boolean;
	lastActivity: number;
	name: string;
	pid: string;
	profilePublicRusId: string;
	recoveryPhone: boolean;
	showWarning: boolean;
	state: ELoginState;
	userId: number;
}

interface IUserBadgeDataUsers extends IUserBadgeItem {
	users: Array<IUserBadgeItem>;
}

export interface IUserBadgeData {
	error: null | string;
	status: number;
	request: any;
	data: IUserBadgeDataUsers;
}
